"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unobserve = exports.observe = void 0;
const error_1 = require("./error");
const subject_def_1 = require("./subject-def");
const util_1 = require("./util");
const getSubjectDefForObservation = (verb, subject) => {
    var _a, _b;
    const def = subject_def_1.SubjectDef.getFor(subject);
    if (!def) {
        const ctorName = (_b = (_a = Object.getPrototypeOf(subject)) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name;
        // Bare object.
        if (!ctorName || ctorName === 'Object') {
            throw new error_1.EcceError(`Cannot ${verb} an object not created by subject().`);
        }
        // Class instance.
        throw new error_1.EcceError(`Cannot ${verb} an instance of a class without a @subject() decorator: "${ctorName}".`);
    }
    return def;
};
const getPropertyForObservation = (verb, subject, key) => {
    const def = getSubjectDefForObservation(verb, subject);
    const prop = def.getProperty(key);
    if (!prop) {
        if (def instanceof subject_def_1.ClassSubjectDef) {
            throw new error_1.EcceError(`Cannot ${verb} a property without an @observable() decorator: "${def.name}.${String(key)}".`);
        }
        throw new error_1.EcceError(`Cannot ${verb} non-existant property: "${def.name}.${String(key)}"`);
    }
    return prop;
};
const observe = (subject, keyOrObserver, observerOrOptions, options) => {
    if (typeof (observerOrOptions) === 'function' && (0, util_1.isPropertyKey)(keyOrObserver)) {
        // Observing a single property
        getPropertyForObservation('observe', subject, keyOrObserver).addObserver(subject, observerOrOptions, options);
        return;
    }
    // Observing entire subject.
    getSubjectDefForObservation('observe', subject)
        .addObserver(subject, keyOrObserver, options);
};
exports.observe = observe;
const unobserve = (subject, keyOrObserver, observer) => {
    if (observer && (0, util_1.isPropertyKey)(keyOrObserver)) {
        // Unobserving a single property.
        getPropertyForObservation('unobserve', subject, keyOrObserver).removeObserver(subject, observer);
        return;
    }
    getSubjectDefForObservation('unobserve', subject)
        .removeObservers(subject, keyOrObserver);
};
exports.unobserve = unobserve;
//# sourceMappingURL=observe.js.map